export default "__VITE_ASSET__BbmbQ$hj__"